webpackJsonp([76456355969304],{

/***/ 1310:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"SortDirection","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"ASC"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"DESC"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-sort-direction-c07e06e1b22a7c839268.js